import { type ReactElement, useState } from 'react';
import { SidebarLayerControl } from '../Controls';
import { BIKE_SECTION } from '../Controls/SidebarLayerControl.types';
import {
    winterBikeRoadsDanderyd,
    winterBikeRoadsLidingo,
    winterBikeRoadsNacka,
    winterBikeRoadsSollentuna,
    winterBikeRoadsSolna,
    winterBikeRoadsStockholm,
} from '../LayerFactories';
import { LeafletMap } from '../Map';
import { type LayerSetupDefinition } from '../Map.types';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

const layers: { [key: string]: LayerSetupDefinition } = {
    'winter-bike-roads-danderyd': { layer: winterBikeRoadsDanderyd(), sections: [BIKE_SECTION] },
    'winter-bike-roads-lidingo': { layer: winterBikeRoadsLidingo(), sections: [BIKE_SECTION] },
    'winter-bike-roads-nacka': { layer: winterBikeRoadsNacka(), sections: [BIKE_SECTION] },
    'winter-bike-roads-sollentuna': { layer: winterBikeRoadsSollentuna(), sections: [BIKE_SECTION] },
    'winter-bike-roads-solna': { layer: winterBikeRoadsSolna(), sections: [BIKE_SECTION] },
    'winter-bike-roads-stockholm': { layer: winterBikeRoadsStockholm(), sections: [BIKE_SECTION] },
};

export const WinterBikePageMap = (props: PageMapProps): ReactElement => {
    const [map, setMap] = useState<Map>();
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        Object.values(layers).forEach((layer) => {
            layer.layer.addTo(map);
        });

        setMap(map);
    };

    return (
        <>
            {map && (
                <SidebarLayerControl
                    map={map}
                    scope="winter-bike-roads-sth"
                    region={mapProps.region.toLowerCase()}
                    layers={{ ...layers }}
                    defaultOpen={false}
                    defaultOnLayers={['rental-bike', 'pump-station', 'bike-roads-gbg', 'bike-parkings-gbg']}
                    sectionsToShow={[BIKE_SECTION]}
                    defaultSection={BIKE_SECTION}
                    sectionHeaders={{ [BIKE_SECTION]: 'Vintercykelvägar' }}
                />
            )}
            <LeafletMap {...mapProps} showMyPosition={true} showMobileFullscreenOverlay={true} onMapInitiated={setupMap} />
        </>
    );
};
